import {
  ArrowRightLeft,
  CalendarClock,
  Database,
  Globe,
  Grid3x3,
  MessageSquare,
  PhoneOff,
} from "lucide-react";

import type { ToolKind } from "../../api";

/** What each tool kind is, in the tenant's language. `once` marks the kinds
 * that only make sense one per assistant — the backend enforces it too. */
export const TOOL_KINDS: {
  kind: ToolKind;
  label: string;
  blurb: string;
  icon: typeof Globe;
  once: boolean;
}[] = [
  {
    kind: "api_request",
    label: "API Request",
    blurb: "Call your own endpoint mid-conversation and use what it returns.",
    icon: Globe,
    once: false,
  },
  {
    kind: "transfer_call",
    label: "Transfer Call",
    blurb: "Hand the caller to a human, with a summary texted ahead.",
    icon: ArrowRightLeft,
    once: true,
  },
  {
    kind: "end_call",
    label: "End Call",
    blurb: "Let the assistant hang up once the conversation is finished.",
    icon: PhoneOff,
    once: true,
  },
  {
    kind: "send_text",
    label: "Send Text",
    blurb: "Text the caller a link or address while they're still on the line.",
    icon: MessageSquare,
    once: true,
  },
  {
    kind: "calcom",
    label: "Cal.com Scheduling",
    blurb: "Check availability and book, reschedule or cancel appointments.",
    icon: CalendarClock,
    once: true,
  },
  {
    kind: "odoo",
    label: "Odoo",
    blurb: "Look up contacts and create leads, events or invoices.",
    icon: Database,
    once: true,
  },
  {
    kind: "press_digit",
    label: "Press Digit",
    blurb: "Press keypad keys when an automated system asks, like \"press 1 to connect\".",
    icon: Grid3x3,
    once: true,
  },
];

export function toolMeta(kind: ToolKind) {
  return TOOL_KINDS.find((t) => t.kind === kind) ?? TOOL_KINDS[0];
}
